import { createSlice } from "@reduxjs/toolkit";

export const contactSlice = createSlice({
    name: "contact",
    initialState: {
        value: {
            searchTerm: "",
            results: [],
            selectedContact: null,
            selectedContacts: [],
            tempData: null
        }
    },
    reducers: {
        setSearchTerm: (state, action) => {
            state.value.searchTerm = action.payload
        },
        setResults: (state, action) => {
            state.value.results = action.payload
        },
        setSelectedContact: (state, action) => {
            state.value.selectedContact = action.payload
        },
        setSelectedContacts: (state, action) => {
            const ids = Array.isArray(action.payload)
                ? Array.from(
                    new Set(
                        action.payload
                            .map((value) => parseInt(value, 10))
                            .filter((value) => Number.isInteger(value) && value > 0)
                    )
                )
                : [];
            state.value.selectedContacts = ids;
            if (state.value.selectedContact && !ids.includes(state.value.selectedContact)) {
                state.value.selectedContact = ids.length ? ids[0] : null;
            }
        },
        toggleSelectedContactSelection: (state, action) => {
            const id = parseInt(action.payload, 10);
            if (!Number.isInteger(id) || id <= 0) {
                return;
            }
            if (state.value.selectedContacts.includes(id)) {
                state.value.selectedContacts = state.value.selectedContacts.filter(
                    (contactId) => contactId !== id
                );
                if (state.value.selectedContact === id) {
                    state.value.selectedContact = state.value.selectedContacts.length
                        ? state.value.selectedContacts[0]
                        : null;
                }
                return;
            }

            state.value.selectedContacts.push(id);
        },
        setTempData: (state, action) => {
            state.value.tempData = action.payload
        },
        resetContacts: (state) => {
            state.value.searchTerm = "";
            state.value.results = []
            state.value.selectedContact = null;
            state.value.selectedContacts = [];
            state.value.tempData = null
        }
    }
})

export const {
    setSearchTerm,
    setResults,
    setSelectedContact,
    setSelectedContacts,
    toggleSelectedContactSelection,
    resetContacts,
    setTempData,
} = contactSlice.actions;

export default contactSlice.reducer;
